<template>
  <div>
    <div>
      <h6 class="text-base inline-block">Details</h6>
    </div>

    <div class="flex -mx-4 mt-8">
      <div class="px-4">
        <ValidationProvider rules="required" vid="issueDate">
          <template #default>
            <BaseFormGroup class="w-48">
              <BaseFormLabel> Issue Date </BaseFormLabel>
              <BaseFormInput v-model="computedIssueDate" type="date" :disabled="disabled" />
            </BaseFormGroup>
          </template>
        </ValidationProvider>
      </div>
      <div class="px-4">
        <BaseFormGroup class="w-48">
          <BaseFormLabel> Invoice Type </BaseFormLabel>
          <BaseFormSelect
            :value="invoiceType"
            :options="invoiceTypeOptions"
            :disabled="disabled || locked"
            class="block"
            @input="$emit('update:invoice-type', $event)"
          />
        </BaseFormGroup>
      </div>
      <div class="px-4">
        <BaseFormGroup class="w-48">
          <BaseFormLabel> Invoice Number </BaseFormLabel>
          <BaseFormInput :value="invoiceNumber" disabled />
        </BaseFormGroup>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider,
  },

  props: {
    invoiceNumber: {
      type: String,
      default: '',
    },
    invoiceType: {
      type: String,
      default: '',
    },
    invoiceIssueDate: {
      type: String,
      default: '',
    },
    disabled: Boolean,
    locked: Boolean,
  },

  data() {
    return {
      invoiceTypeOptions: [
        { label: 'Invoice', value: 'invoice' },
        { label: 'Credit Note', value: 'credit note' },
      ],
    };
  },

  computed: {
    computedIssueDate: {
      get() {
        return this.invoiceIssueDate;
      },
      set(value) {
        this.$emit('update:invoice-issue-date', value);
      },
    },
  },
};
</script>
